import { useTaal } from "@/contexts/TaalContext";

/** B1 (4 nov 2026): de tussenronde van de proactieve wachter.
 *
 *  BOVEN WAT JOU NODIG HEEFT: mail van een mens, een afspraak die begint voor de volgende ronde,
 *  een taak met een tijd die afloopt of verlopen is. DAARONDER, INGEKLAPT, WAT STIL BLEEF: lijst-,
 *  automatische en eigen mail. Een bron die niet gelezen kon worden, staat er met naam.
 */
const OP_GLAS = { geen_koppeling: "Niet gekoppeld", storing: "Kon er niet bij" };

export default function WachtrondeBlok({ ronde }) {
  const { t } = useTaal();
  if (ronde.mislukt) {
    return (
      <p className="text-xs text-[hsl(var(--destructive))]" data-testid="wachtronde-mislukt">
        {t("De ronde gaf het op na vijf pogingen: {fout}", { fout: ronde.mislukt })}
      </p>
    );
  }
  const mail = ronde.mail || [];
  const agenda = ronde.agenda || [];
  const taken = ronde.tasq || [];
  const stil = ronde.stil || [];
  const niets = !mail.length && !agenda.length && !taken.length;
  const fouten = (ronde.bronnen || []).filter((b) => b.uitkomst === "storing");
  return (
    <section className="space-y-2" data-testid="wachtronde">
      <p className="text-xs text-[hsl(var(--muted-foreground))]">
        {t("Nagelopen van {van} tot {tot}.", { van: ronde.van, tot: ronde.tot })}
      </p>
      {niets && !fouten.length && <p className="text-sm" data-testid="wachtronde-niets">{t("Niets dat op je wacht.")}</p>}
      {mail.length > 0 && (
        <div data-testid="wachtronde-mail">
          <h3 className="text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{t("Mail van een mens")}</h3>
          <ul className="text-sm">
            {mail.map((m) => (
              <li key={m.id} className="break-words">
                <span className="text-xs tabular-nums mr-2">{m.tijd}</span>{m.afzender}: {m.onderwerp}
              </li>
            ))}
          </ul>
        </div>
      )}
      {agenda.length > 0 && (
        <div data-testid="wachtronde-agenda">
          <h3 className="text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{t("Begint binnenkort")}</h3>
          <ul className="text-sm">
            {agenda.map((a, i) => (
              <li key={i} className="break-words"><span className="text-xs tabular-nums mr-2">{a.begin}</span>{a.titel}</li>
            ))}
          </ul>
        </div>
      )}
      {taken.length > 0 && (
        <div data-testid="wachtronde-tasq">
          <h3 className="text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{t("Taken met een tijd")}</h3>
          <ul className="text-sm">
            {taken.map((k, i) => (
              <li key={i} className="break-words">
                <span className="text-xs tabular-nums mr-2">{k.deadline}</span>{k.titel}
                {k.verlopen && <span className="ml-1 text-[hsl(var(--destructive))]">({t("verlopen")})</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
      {fouten.map((b) => (
        <p key={b.bron} className="text-xs text-[hsl(var(--destructive))]" data-testid="wachtronde-storing">
          {b.bron}: {t(OP_GLAS[b.uitkomst] || b.uitkomst)}
        </p>
      ))}
      {stil.length > 0 && (
        <details className="text-sm" data-testid="wachtronde-stil">
          <summary className="cursor-pointer min-h-11 flex items-center text-xs text-[hsl(var(--muted-foreground))]">
            {t("Stil gebleven ({n})", { n: stil.length })}
          </summary>
          <ul>
            {stil.map((m) => (
              <li key={m.id} className="break-words text-[hsl(var(--muted-foreground))]">
                <span className="text-xs tabular-nums mr-2">{m.tijd}</span>{m.afzender}: {m.onderwerp}
              </li>
            ))}
          </ul>
        </details>
      )}
    </section>
  );
}
